import { Action, createReducer, on } from '@ngrx/store';
import { ApplicationModel } from '../../model';
import { ApplicationActions } from './application.actions';
import { Retrieve } from '@core/data-access';

export const APPLICATION_FEATURE_KEY = 'application';

export interface ApplicationState {
  accessToken: string | null;
  application: ApplicationModel | null;
  corppassCode: string | null;
  retrieve: Retrieve | null;
}

export interface ApplicationPartialState {
  readonly [APPLICATION_FEATURE_KEY]: ApplicationState;
}

export const initialApplicationState: ApplicationState = {
  accessToken: null,
  application: null,
  corppassCode: null,
  retrieve: null,
};

const reducer = createReducer(
  initialApplicationState,
  on(ApplicationActions.init, state => ({ ...state })),
  on(ApplicationActions.setAccessToken, (state, { accessToken }) => ({ ...state, accessToken })),
  on(ApplicationActions.setApplication, (state, { application }) => ({ ...state, application })),
  on(ApplicationActions.setCorppassCode, (state, { corppassCode }) => ({ ...state, corppassCode })),
  on(ApplicationActions.setRetrieve, (state, { retrieve }) => ({ ...state, retrieve })),
);

export function applicationReducer(state: ApplicationState | undefined, action: Action) {
  return reducer(state, action);
}
